// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__25LVZ","light":"Tag_light__tMX1F"};